module.exports = __webpack_public_path__ + "img/np.ecc31e5.svg";